export function dehydrate(subReference) {
  return subReference
}

export function hydrate({ subref_content, subref_type, entry_reference, pk }) {
  return {
    subref_content,
    subref_type,
    entry_reference,
    pk,
  }
}

export function hydrateAnswerSetSubReference({
  subref_content,
  subref_type,
  answerset_reference,
  pk,
}) {
  return {
    subref_content,
    subref_type,
    answerset_reference,
    pk,
  }
}
